import { render, staticRenderFns } from "./bindStaff.vue?vue&type=template&id=14776c96&scoped=true&"
import script from "./bindStaff.vue?vue&type=script&lang=js&"
export * from "./bindStaff.vue?vue&type=script&lang=js&"
import style0 from "./bindStaff.vue?vue&type=style&index=0&id=14776c96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14776c96",
  null
  
)

export default component.exports